<template>
<div class="box-labourParticulars">
    <div class="nav">
        <img src="../../assets/up.png" alt="" class="upClass" @click="getOnPage1">
        薪酬福利
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-actve">薪资查询</h4>
                    <p class="actve">1. EHR系统查询流程</p>
                    <span class="spanClass">每月10日起，登陆EHR系统（http://ehr.xdf.cn）查询工资明细。点击【自助服务】-【薪资和课酬】-【薪资单】。</span>
                    <img src="../../assets/15.jpeg" alt="" class="classImage">
                    <sup id="box_text_content">长按观看视频教程</sup>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-actve">薪资查询</h4>
                    <p>2. 云办公APP查询流程</p>
                    <span class="spanClass active">登陆云办公APP，点击【HR自助】-【薪资单】（首次进入需绘制手势密码，请牢记密码）。</span>
                    <img src="../../assets/16.jpeg" alt="" class="classImage">
                    <sup id="box_text_content">长按观看视频教程</sup>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {

        };
    },
    methods: {
        getOnPage1(){
            var name = this.$route.params.name
            console.log(name)
            if(name == 'we'){
                this.$router.push({name:'IssueManpower'})
            }else{
                this.$router.push({name:'WelfareRemuneration'})
            }
        },
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "555"
                }
            })
        },
    },
    mounted() {
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical", // 垂直切换选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}
.classImage {
    width: 30%;
    display: block;
    margin: 20px auto;
}
.QRcode {
    display: block;
    margin: 10px auto;
}

.contentImg {
    width: 100%;
    display: block;
    margin-top: 15px;
}
#box_text_content {
    width: 100%;
    display: block;
    font-size: 12px;
    color: #ccc;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/WelfareRemuneration/welfareRemuneration2.vue